import { render } from "./GlobalError.vue?vue&type=template&id=cb1219ca&scoped=true"
import script from "./GlobalError.vue?vue&type=script&lang=js"
export * from "./GlobalError.vue?vue&type=script&lang=js"

import "./GlobalError.vue?vue&type=style&index=0&id=cb1219ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1219ca"]])

export default __exports__